<template>
  <div>
    <v-expand-transition>
      <div v-if="!expandedRef">
        <slot name="less" />
        <a @click="expandedRef = true" class="d-block mt-1 pointer">
          Show More
        </a>
      </div>
    </v-expand-transition>
    <v-expand-transition>
      <div v-if="expandedRef">
        <slot name="more" />
        <a @click="expandedRef = false" class="d-block mt-1 pointer">
          Show Less
        </a>
      </div>
    </v-expand-transition>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";

const props = withDefaults(
  defineProps<{
    expanded?: boolean;
  }>(),
  {
    expanded: false,
  },
);

const expandedRef = ref(props.expanded);
</script>

<style scoped>
.pointer {
  cursor: pointer;
}
</style>
